// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-mfdE","sendMessageForm":"styles_sendMessageForm__eLkIo"};